import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const serviceFeesTiersQuery = gql`
  query TopupServiceFeeTiers($currency: String, $tenantId: ID) {
    topupServiceFeesTiers(currency: $currency, tenantId: $tenantId) {
      globallyEnabled
      tiers {
        uuid
        baseServiceFee
        tierServiceFee
        startValue
        endValue
        tenant
        baseServiceFeeRate
        tierServiceFeeRate
      }
    }
  }
`

export const serviceFeesTiersKey = getQueryNames(serviceFeesTiersQuery)[0]

export default serviceFeesTiersQuery
